export default defineNuxtPlugin(() => {
    const entryStore = useEntryStore()
    const micrositeStore = useMicrositeStore()

    // If the server provided an entry that is a microsite, initialize the microsite
    if (!isEmpty(entryStore.entry) && ['ds_MicrositeHomepage_Entry', 'ds_MicrositePage_Entry'].includes(entryStore.entry.__typename)) {
        micrositeStore.initMicrosite(entryStore.entry)
    }
})